var Payment = xClass("WechatgamePayment")
const dcUtil = require("entry/dc")
const STORAGE_KEY = "IOS_PAYMENT_ORDERID"
Payment.prototype.ctor = function () {

}

/**
 * 微信米大师接口错误码转义
 * @param {Number} errCode 错误码
 * @returns {String} 错误信息的中文描述
 * @see https://developers.weixin.qq.com/miniprogram/document/midas-payment/requestMidasPayment.html?t=201812
 * @todo 修改为从strings配置中读取
 */
Payment.prototype.errCodeToMsg = function (errCode) {
    if (typeof errCode == "string") {
        errCode = parseInt(errCode)
    }
    let msg = null;
    switch (errCode) {
        case -1:
            msg = "系统失败";
            break;
        case -2:
            msg = "支付取消";
            break;
        case -15001:
            msg = "支付接口错误，缺少参数";
            break;
        case -15002:
            msg = "支付接口错误，参数不合法";
            break;
        case -15003:
            msg = "支付接口错误，订单重复";
            break;
        case -15004:
            msg = "支付接口错误，后台错误";
            break;
        case -15006:
            msg = "支付接口错误，appId 权限被封禁";
            break;
        case -15006:
            msg = "支付接口错误，货币类型不支持";
            break;
        case -15007:
            msg = "支付接口错误，订单已支付";
            break;
        case 1:
            msg = "支付接口错误，用户取消支付";
            break;
        case 2:
            msg = "支付接口错误，客户端错误, 判断到小程序在用户处于支付中时,又发起了一笔支付请求";
            break;
        case 3:
            msg = "支付接口错误，Android 独有错误：用户使用 Google Play 支付，而手机未安装 Google Play";
            break;
        case 4:
            msg = "支付接口错误，iOS 独有错误：用户在 AppStore 中把支付关闭";
            break;
        case 5:
            msg = "支付接口错误，Google 或者 Apple 错误";
            break;
        case 6:
            msg = "支付接口错误，其他错误";
            break;
        case 1000:
            msg = "参数错误";
            break;
        default:
            msg = null;
            break;
    }
    return msg;
}
// 获取失败类型
Payment.prototype.getFailType = function (errCode) {
    // cc.log("[Pay]","WechatgamePayment getFailType errCode",errCode);
    let fail_type = 1;
    if (errCode == 1 || errCode == -2){
        fail_type = -1;
    }
    return fail_type;
}

function toParams(param){
    var result = ""
    for (let name in param) {
        // if (typeof param[name] != 'function') {
            result += "&" + name + "=" + param[name];
        // }
    }
    return result.substring(1)
}
function removeStorage(){
    cc.sys.localStorage.removeItem(STORAGE_KEY)
}
function writeStorage(storage) {
    cc.sys.localStorage.setItem(STORAGE_KEY, JSON.stringify(storage));
}
function readStorage() {
    let s = cc.sys.localStorage.getItem(STORAGE_KEY);
    if (s) {
        try {
            s = JSON.parse(s);
        } catch (e) {
            s = null;
        }
    }
    return s;
}
Payment.prototype.getEnvVersion = function () {
    // let _qamode = getParameterByName("_qamode")
    let _resver = getParameterByName("_resver")
    let jump_applet = MetaManager.getIosPayConfig().jump_applet
    let Http = require("../utils/Http")
    console.log("getEnvVersion jump_applet ",jump_applet,Http.hostQuery)
    // let str  = jump_applet
    // if (_resver) str += "  "+_resver
    // str += "   " + Http.hostQuery
    // Toast.make("getEnvVersion "+str)
    if (Http.hostQuery != "env=qa" && !_resver){
        console.log("线上环境 跳转默认参数 release")
        jump_applet = "release"
    }
    return jump_applet
}
Payment.prototype.getCurEnv = function(str) {
    let env = "prod"
    let _resver = getParameterByName("_resver")
    if (_resver ){
        env = _resver
    }
    let Http = require("../utils/Http")
    if (Http.hostQuery == "env=qa"){
        env = "stage"
    }
    return env

}

//生成预订单
Payment.prototype.iosbuy = function (data, successCallback, failCallback, closeCallback) {
    let self = this
    console.log("iospay iosbuy data", data)
    // let productId =     
    let ext = data.ext || {};
    ext.iosPay = true
    let payType = UserManager.getInstance().getIosPayType() //跳转类型 h5  mini
    console.log("iospay payType", payType)


    // var goodsName = getText("goods.name.text" + tostring(data.dcGoodsId))
    // console.log("iospay goodsname", data.dcGoodsId, goodsName)
    // console.log("iospay UserManager.getInstance().profile.name", UserManager.getInstance().profile.name)
    let Http = require("../utils/Http")
    let typeN = 0
    let params = {}
    if (payType != "mini") {
        typeN = 1
        params = {
            good_name  : getText("goods.name.text" + tostring(data.dcGoodsId), null, data.money + "元礼包"),
            good_price : data.money,
            nick_name  : UserManager.getInstance().profile.name,
            uid : data.uid,
    
            productId: data.productId,
            zoneId: META.user.serverid,
            ext :  JSON.stringify(ext),
            gid: window.UserManager && UserManager.hasInstance() && UserManager.getInstance().uid || "1",
            dcsession_id: dcUtil.getDCSession(),
            seq_id: META.seqId,
            gameversion: META.version,
            udid: b64Encode(UserManager.getInstance().uid),
            level:  UserManager.getInstance().user.topLevelId,
            goods_id:  data.dcGoodsId,
            dc_session:  data.dcSession,
            HTTP_HOST : getAlias(HTTP_HOST),
            HTTP_HOST_QUERY: Http.hostQuery,//HTTP_HOST_QUERY
            DC_HOST: DC_HOST,
            _schema_cver: dcUtil.getSchemaClentVersionValue(),
            LOG_HOST: LOG_HOST || "",
            env: self.getCurEnv()
        }
        if(!params.nick_name) params.nick_name = "海滨消消乐玩家"
        if (params.nick_name.indexOf("#")>-1){
            params.nick_name = "海滨消消乐玩家"
        }
    }
    console.log("iospay params", params)
    let h5_reason = b64Encode(JSON.stringify(params))
    console.log("iospay params h5_reason ", h5_reason)
    function onSuccess(resp) {
        let resData = resp.data
        // "wx532ce72680311514"
        let iosPayApplet = resData.iosPayApplet
        if (!iosPayApplet) {
            failCallback({
                code: -1,
                data: "支付取消，请重新登录"
            })
            return
        }
        
        const GlobalEvent = require("hecore/EventDispatcher").Event
        GlobalEventDispatcher.getInstance().dispatchEvent(GlobalEvent.new(kGlobalEvents.kOneOrderGenerate, { orderId: resData.orderId }));
         
        console.log("iospay createorder success data", resData)
        ext.orderId = resData.orderId
        let needData = {
            good_name  : getText("goods.name.text" + tostring(data.dcGoodsId), null, data.money + "元礼包"),
            good_price : data.money,
            nick_name  : UserManager.getInstance().profile.name,
            uid : data.uid,
            game_order_id: resData.orderId,

            productId: data.productId,
            zoneId: META.user.serverid,
            // openid: META.user.openid,
            // sessionid: META.user.sessionid,
            ext :  JSON.stringify(ext),
            
            // timeStamp: resData.timeStamp,
            // nonceStr: resData.nonceStr,
            // package: resData.packageStr,
            // signType: resData.signType,
            // paySign: resData.sign,
            gid: window.UserManager && UserManager.hasInstance() && UserManager.getInstance().uid || "1",
            dcsession_id: dcUtil.getDCSession(),
            seq_id: META.seqId,
            gameversion: META.version,
            udid: b64Encode(UserManager.getInstance().uid),
            level:  UserManager.getInstance().user.topLevelId,
            goods_id:  data.dcGoodsId,
            dc_session:  data.dcSession,
            HTTP_HOST : getAlias(HTTP_HOST),
            HTTP_HOST_QUERY: Http.hostQuery,//HTTP_HOST_QUERY
            DC_HOST: DC_HOST,
            _schema_cver: dcUtil.getSchemaClentVersionValue(),
            LOG_HOST: LOG_HOST || "",
            env: self.getCurEnv()
        }
        if (payType == "h5"){
            needData = {
                uid : data.uid,
                game_order_id: resData.orderId,
                good_price : data.money,
                env: self.getCurEnv()
            }
        }
        console.log("iospay needdata", needData, toParams(needData))
        console.log("iospay iosPayApplet", iosPayApplet)
        if (payType == "mini"){
            wx.navigateToMiniProgram({
                appId: iosPayApplet,
                path: 'pages/place-order/place-order?' + toParams(needData),
                extraData: needData,
                envVersion: self.getEnvVersion(),//'trial'
                success(res) {
                    // self.iospay()
                    // Toast.make("success")
                    data.orderId = needData.game_order_id
                    data.name = needData.good_name
                    self.iosPay(data, successCallback, failCallback, closeCallback)
                },
                fail(res){
                    console.log("iospay tominifail res", res)
                    if (res.errMsg){
                        if (res.errMsg == "navigateToMiniProgramWithoutTapCheck:fail cancel"){
                            console.log("正常取消跳转无需报警")
                        }else{
                            window.logCenter && logCenter.error(new Error(`iosPayJumpFail,${res.errMsg}`), 'HBXXL_PAY_ERROR');
                        }
                    }
                    //res.errMsg
                    DCAssist.dc4IosGotoBuyCashGoodsFail(data.dcSession, data.dcScence, data.dcGoodsId, res.errMsg, data.dcEntry)
                    failCallback({
                        code: -1,
                        data: "支付取消"
                    })
                }
            })
        }else{
            // let showTitle = getText("goods.name.text" + tostring(data.dcGoodsId), null, data.money + "元礼包")
            let showTitle = "订单请求中，请勿点击此处"
            if ( needData.env!= "prod") showTitle = `${showTitle}(${needData.env})`
            DCAssist.dc4ReminderShow(data.dcSession)
            data.orderId = needData.game_order_id
            data.name = getText("goods.name.text" + tostring(data.dcGoodsId), null, data.money + "元礼包")
            self.writeStorageCustomerService(data)
            const isAuto = PayManager.getInstance().isCustomerAutoPay();
            const sessionFrom = isAuto ? JSON.stringify(needData) : "456";
            mini.openCustomerServiceConversation({
                sessionFrom,
                sendMessageTitle:showTitle,
                sendMessagePath: toParams(needData),
                sendMessageImg:"https://statich5clover.happyelements.com/resource/upload/wx_pay_link_bg_2_1.jpg",
                showMessageCard: !isAuto,
                success(res) {
                    // self.iospay()
                    // Toast.make("success")
                    console.log("iospay openCustomerServiceConversation success")
                    // data.orderId = needData.game_order_id
                    // data.name = getText("goods.name.text" + tostring(data.dcGoodsId), null, data.money + "元礼包")
                    self.iosPay(data, successCallback, failCallback, closeCallback)
                    DCAssist.dc4IosGotoBuyCashGoodsSuccess(data.dcSession, data.dcScence, data.dcGoodsId, data.orderId,h5_reason, data.dcEntry)
                },
                fail(res){
                    DCAssist.dc4IosGotoBuyCashGoodsFail(data.dcSession, data.dcScence, data.dcGoodsId, res.errMsg, data.dcEntry)
                    failCallback({
                        code: -1,
                        data: "支付取消"
                    })
                }
            });
        }

    }

    function onFail(evt) {
        let errcode = evt ? evt.data : -1;
        cc.log("[################]iospay createorder failed evt" , evt)

        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = WechatgamePreOrderHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({type:typeN,params:params})



}
// 客服由于回调问题点击就存储订单信息
Payment.prototype.writeStorageCustomerService = function (data) {
    console.log("iospay writeStorageCustomerService", data)
    writeStorage({
        orderId : data.orderId,
        name : data.name,
        dcGoodsId : data.dcGoodsId,
        dcSession : data.dcSession,
        dcScence : data.dcScence,
        dcEntry : data.dcEntry,
        money : data.money,
        dcSource : data.dcSource
    })

}
//轮询订单
Payment.prototype.iosPay = function (data, successCallback, failCallback) {
    let self = this
    let checkNum = 0
    let isFinish = false
    global.iosPaymentTimer = 0
    showGlobalMask("IOS_PAYMENT");

    writeStorage({
        orderId : data.orderId,
        name : data.name,
        dcGoodsId : data.dcGoodsId,
        dcSession : data.dcSession,
        dcScence : data.dcScence,
        dcEntry : data.dcEntry,
        money : data.money,
        dcSource : data.dcSource
    })

    // data.orderId = "20220418104416553nLDDLiP80140329"
    function paySuccess(resp) {
        if (isFinish) return
        isFinish = true
        console.log("iospay checkorder paycuccess")
        cc.Director.getInstance().getScheduler().unscheduleScriptEntry(global.iosPaymentTimer)
        global.iosPaymentTimer = 0
        // cc.log("pay resp.data: ", resp.data)
        // cc.log(resp.data)
        removeStorage()
        successCallback({ orderId: data.orderId});
        hideGlobalMask("IOS_PAYMENT");
    }

    function payFail() {
        console.log("iospay checkorder payfail")
        if (checkNum++ >= 2){
            if (isFinish) return
            isFinish = true
            cc.Director.getInstance().getScheduler().unscheduleScriptEntry(global.iosPaymentTimer)
            global.iosPaymentTimer = 0
            failCallback({
                code: -1,
                data: "支付失败"
            })
            hideGlobalMask("IOS_PAYMENT");
            if (!UserManager.getInstance().isUsedCustomerPay() && PayManager.getInstance().isIosCustomerPay()){
                PayManager.getInstance().showFailGuidePanel(()=>{},{
                    session: data.dcSession,
                    goods_id:data.dcGoodsId,
                    order_id:data.orderId
                })
            }
        }
    }


    function checkPayState(){
        console.log("iospay checktime " + checkNum)
        function onSuccess(resp) {
            cc.log("iospay checkorder success resp.data: ", resp.data)
            let status = resp.data.status
            for(index in status){
                let order = status[index]
                if (order.orderId == data.orderId && order.status == 3){
                    paySuccess()
                    return
                }
            }
            payFail()
        }

        let http = WechatgmaeCheckOrderHttp.new(true)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, payFail)
        http.addEventListener(Events.kCancel, payFail)
        http.load(data.orderId)
    }

    // checkPayState()
    global.iosPaymentTimer = cc.Director.getInstance().getScheduler().scheduleScriptFunc(checkPayState, 1, false)

}
Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    let system = mini.getSystemInfoSync().system
    if (system.indexOf("iOS") == 0) {
        if (UserManager.getInstance().canIosToMiniPay()){
            self.iosbuy(data, successCallback, failCallback, closeCallback)
            // self.iosPay(data, successCallback, failCallback, closeCallback)
        }else {
            failCallback({
                code: -1,
                data: "暂时不支持iOS平台"
            })
        }
        return
    }


    let productId = data.productId    
    let ext = data.ext;

    function onSuccess(resp) {
        let data = resp.data
        
        const GlobalEvent = require("hecore/EventDispatcher").Event
        GlobalEventDispatcher.getInstance().dispatchEvent(GlobalEvent.new(kGlobalEvents.kOneOrderGenerate, { orderId: data.orderId }));
        
        function pay() {
            let payData = {
                orderId: data.orderId,
                productId: productId,
                zoneId: META.user.serverid,
                ext
            }
            cc.log("payData", payData)
            self.pay(payData, successCallback, failCallback, closeCallback)
        }
        console.log("Payment buy data", data)
        let balance = data.balance
        let buyQuantity = data.buyQuantity
        if (balance < buyQuantity) {
            let payNew = ()=>{
                try {
                    let value_num = 0
                    if (data && data.buyQuantity) value_num = data.buyQuantity * 100
                    DnSdkTool.getInstance().onPurchase(value_num)
                } catch (error) {
                }
                pay()
            }
            // 余额不足，充值
            let payment = {
                mode: "game",
                env: data.env,
                offerId: data.offerId,
                currencyType: "CNY",
                platform: data.platform,
                buyQuantity: data.buyQuantity,
                zoneId: META.user.serverid,
                success: payNew,
                fail: function ({
                    errMsg,
                    errCode
                }) {
                    let fail_type = self.getFailType(errCode);
                    failCallback({
                        code: errCode,
                        data: errMsg,
                        msg: self.errCodeToMsg(errCode),
                        type: fail_type,//1代表是第三方掉起支付失败
                        orderId: data.orderId 
                    })
                }
            }
            cc.log("wechat pay", payment)
            mini.requestMidasPayment(payment)
        } else {
            // 余额够，不需要充值，直接购买
            pay()
        }
    }

    function onFail(evt) {
        let errcode = evt ? evt.data : -1;
        cc.log("[################]getinfohttp failed evt" , evt)
        // if (errcode == "760810"){
        //     require("clover/sns/SnsProxy").getInstance().showDialog({
        //         text: getText("error.tip.761962"),
        //         needOkBtn: true,
        //         okBtnText: getText("bank_refreshInfo_btn"),
        //     }, () => {
        //     })
        // }else{
      
        // }
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let param = {
        productId: productId,
        zoneId: META.user.serverid,
        openid: META.user.openid,
        sessionid: META.user.sessionid,
        ext
    }
    let http = WechatgamePaymentGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(param);
}

Payment.prototype.pay = function (data, successCallback, failCallback, closeCallback,retryCount) {
    let self = this

    function onSuccess(resp) {
        cc.log("pay resp.data: ", resp.data)
        cc.log(resp.data)

        successCallback({ orderId: data.orderId});
    }

    function onFail(resp) {
        cc.log("pay failed resp: ", resp)
        if (retryCount == null) retryCount = 0;
        if (resp.data == 760214){
            self.schedule = cc.Director.getInstance().getScheduler().scheduleScriptFunc(function (){
                cc.Director.getInstance().getScheduler().unscheduleScriptEntry(self.schedule);
                self.schedule = null;
                if(retryCount++ < 10){
                    self.pay(data,successCallback,failCallback,closeCallback,retryCount);
                } else {
                    failCallback({
                        code: -1,
                        data: "支付正在进行中"
                    }) 
                }
            }, 3);//, retryCount * 5);
            
            // if (retryCount == 0){
            //     failCallback({w
            //         code: -1,
            //         data: "支付正在进行中"
            //     })
            // }
        }
        else{
            failCallback({
                code: -1,
                data: "支付失败"
            })
        }
    }

    function onCancel() {
        failCallback({
            code: -1,
            data: "支付取消"
        })
    }

    let http = WechatgamePaymentPayHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        orderId: data.orderId,
        productId: data.productId,
        zoneId: META.user.serverid,
        openid: META.user.openid,
        sessionid: META.user.sessionid,
        ext: data.ext
    })
}

module.exports = Payment